import { themeVariables } from "Components/theme";
import { DivWithTooltip } from "Components/withPopover";
import pinFilledBase64 from "Content/images/graph/pinFilledBase64";
import React, { useCallback, useMemo, useRef } from "react";
import locale from "./unPinIcon.locale";
const SIZES = {
    UNPIN_ICON_BORDER_RADIUS: 2
};
export default function UnPinIcon(props) {
    var _a, _b;
    const popoverRef = useRef(null);
    const handleUnPin = useCallback((e) => {
        var _a;
        if (props.data && props.onUnPin) {
            e.stopPropagation();
            if ((_a = popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current) === null || _a === void 0 ? void 0 : _a.instance)
                popoverRef.current.instance.hide();
            props.onUnPin(props.data);
        }
    }, [props.data, props.onUnPin]);
    const unPinIconStyles = useMemo(() => {
        var _a, _b;
        return ((_a = props.data) === null || _a === void 0 ? void 0 : _a.GroupId) && !((_b = props.data) === null || _b === void 0 ? void 0 : _b.PinnedToGroup)
            ? {
                width: props.iconSize,
                height: props.iconSize,
                borderRadius: SIZES.UNPIN_ICON_BORDER_RADIUS,
                position: "absolute",
                right: props.positionRight !== undefined ? props.positionRight : props.iconSize / 2,
                top: props.positionTop !== undefined ? props.positionTop : props.iconSize / 2,
                zIndex: 2,
                overflow: "visible",
                backgroundColor: "#fff",
                border: `1px solid ${themeVariables["gray-200"]}`,
                cursor: "pointer",
                display: "grid",
                justifyContent: "center",
                alignItems: "center"
            }
            : undefined;
    }, [
        (_a = props.data) === null || _a === void 0 ? void 0 : _a.GroupId,
        (_b = props.data) === null || _b === void 0 ? void 0 : _b.PinnedToGroup,
        props.positionRight,
        props.positionTop,
        props.iconSize
    ]);
    if (!props.data.GroupId || props.data.PinnedToGroup)
        return null;
    return (React.createElement(DivWithTooltip, { style: unPinIconStyles, popoverRef: popoverRef, onClick: handleUnPin, popoverContent: !props.disableHint ? locale.UNPIN_NODE : "", zIndex: props.zIndex, className: props.className, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave }, props.isExporting ? (React.createElement("img", { src: pinFilledBase64 })) : (React.createElement("i", { className: "icon-pin-filled font-h5 text-gray-400" }))));
}
UnPinIcon.defaultProps = {
    iconSize: 22,
    zIndex: parseInt(themeVariables["zindex-devextreme-dx-menu-base"])
};
